import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaMicrophone } from 'react-icons/fa';
import '../AIInterviewEnrolledCourse/Interview.css';
import { toast } from 'react-toastify';
import { AI_INTERVIEW_URL, INTERVIEWMANAGEMENT_URL, PROGRAMMINGSERVICE_URL } from '../../../Services/courseService';
import ClipLoader from 'react-spinners/ClipLoader';
import axios from 'axios';
import QuestionEditor from './QuestionEditor';
import interviewerImg from '../../../Assets/Robot.jpg'


const AIInterviewExamUnenrolledCourse = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isPermissionGranted, setIsPermissionGranted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isFullscreen, setIsFullscreen] = useState(true);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timer, setTimer] = useState(0);
  const [isAudioRecording, setIsAudioRecording] = useState(false);
  const [audioRecordings, setAudioRecordings] = useState([]);
  const [videoStream, setVideoStream] = useState(null);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [isAnswered, setIsAnswered] = useState(false);
  const [answerText, setAnswerText] = useState('');
  const videoRef = useRef(null);
  const [hasRecordedAnswer, setHasRecordedAnswer] = useState(false);
  const [tabSwitchAttempts, setTabSwitchAttempts] = useState(0);
  const [isExamEnded, setIsExamEnded] = useState(false);
  const [isExamSubmitted, setIsExamSubmitted] = useState(false);
  const [showEndPopup, setShowEndPopup] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [isLoadingExam, setIsLoadingExam] = useState(false);
  const [isLoadingFinalReport, setIsLoadingFinalReport] = useState(false);
  const [isGeneralLoading, setIsGeneralLoading] = useState(false);

  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const { courseName, experience } = useParams();
  const [resume, setResume] = useState();
  const [signalStrength, setSignalStrength] = useState(0);
  const [ping, setPing] = useState(null);

  const fetchQuestions = async () => {
    setIsLoadingExam(true);
    const formData = new FormData();
    formData.append("file", resume);
    localStorage.removeItem("length")

    try {
      const response = await fetch(
        `${AI_INTERVIEW_URL}/experience/fetch?role=${courseName}&experienceYears=${experience}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      console.log(data.length)

      localStorage.setItem("length", data.length)

      localStorage.setItem("experience", experience)

      if (data?.length) {
        setQuestions(data.map((question) => ({ question, isCoding: false })));
        startInterview();
      } else {
        toast.dismiss();

        toast.error(data.error);
        stopRecording();
        if (document.fullscreenElement) {
          exitFullscreen();
        }
        setIsPermissionGranted(false);
        // toast.error("Please upload a properly formatted resume with experience or projects if you are a fresher.");

        throw new Error("");
      }
    } catch (error) {
      console.error("Error in fetchQuestions:", error);
      throw new Error("File size exceeds the 2MB limit.");


    } finally {
      setIsLoadingExam(false);
    }
  };


  const measurePing = async () => {
    const start = Date.now();
    try {
      await fetch("https://www.google.com/favicon.ico", { method: 'HEAD', mode: 'no-cors' });
      const latency = Date.now() - start;
      setPing(latency);
    } catch {
      setPing(null);
    }
  };

  useEffect(() => {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    const calculateSignal = (downlink) => {
      if (!navigator.onLine || downlink === 0 || downlink == null) return 0;
      if (downlink >= 10) return 4;
      if (downlink >= 5) return 3;
      if (downlink >= 2) return 2;
      if (downlink >= 0.5) return 1;
      return 0;
    };

    const updateSignalAndPing = () => {
      const strength = calculateSignal(connection?.downlink);
      setSignalStrength(strength);
      measurePing();
    };

    updateSignalAndPing();

    if (connection) {
      connection.addEventListener('change', updateSignalAndPing);
    }

    window.addEventListener('online', updateSignalAndPing);
    window.addEventListener('offline', updateSignalAndPing);

    const intervalId = setInterval(updateSignalAndPing, 10000);

    return () => {
      if (connection) {
        connection.removeEventListener('change', updateSignalAndPing);
      }
      window.removeEventListener('online', updateSignalAndPing);
      window.removeEventListener('offline', updateSignalAndPing);
      clearInterval(intervalId);
    };
  }, []);

  const renderSignalBars = () => (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '20px',
      display: 'flex',
      alignItems: 'flex-end',
      zIndex: 1000,
      backgroundColor: 'rgba(255,255,255,0.9)',
      padding: '8px 12px',
      borderRadius: '10px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      userSelect: 'none',
      fontFamily: 'Arial, sans-serif'
    }}>
      {[1, 2, 3, 4].map((level) => (
        <div
          key={level}
          style={{
            width: '6px',
            height: `${level * 8 + 4}px`,
            marginRight: '5px',
            backgroundColor: level <= signalStrength ? (signalStrength < 2 ? 'red' : '#4caf50') : '#ddd',
            borderRadius: '2px',
            transition: 'background-color 0.3s ease'
          }}
        />
      ))}
      <span style={{ marginLeft: '12px', fontSize: '0.9rem', color: '#333', whiteSpace: 'nowrap' }}>
        {ping !== null ? `Ping: ${ping}ms` : 'Ping: --'}
      </span>
    </div>
  );


  const handleResumeChange = (event) => {
    const file = event.target.files[0];
    const validTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];

    if (file && validTypes.includes(file.type)) {
      localStorage.setItem(`resume-${courseName}`, file.name);
      setResume(file);
      setErrorMessage("");
    } else {
      setErrorMessage("Please upload a valid PDF, DOC, or DOCX file.");
    }
  };


  useEffect(() => {
    if (isPermissionGranted) {
      setTimer(180)

      const interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            return prevTimer - 1;
          } else {
            clearInterval(interval);
            return 0;
          }
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isPermissionGranted]);

  const startRecording = (stream) => {
    const mimeTypes = [
      'video/mp4',
      'video/webm;codecs=vp8,opus',
      'video/ogg'
    ];
    let supportedMimeType = null;

    for (let mimeType of mimeTypes) {
      if (MediaRecorder.isTypeSupported(mimeType)) {
        supportedMimeType = mimeType;
        break;
      }
    }

    if (!supportedMimeType) {
      console.error('No supported MIME type found');
      return;
    }

    const recorder = new MediaRecorder(stream, { mimeType: supportedMimeType });
    let chunks = [];

    recorder.ondataavailable = (event) => {
      chunks.push(event.data);
    };

    recorder.onstop = () => {
      const videoBlob = new Blob(chunks, { type: supportedMimeType });
      blobToBase64(videoBlob).then((base64VideoData) => {
        const sendChunkPromise = new Promise((resolve, reject) => {

          try {
            resolve();
          } catch (error) {
            reject(error);
          }
        });

        sendChunkPromise
          .then(async () => {
            await endInterview(videoBlob);
          })
          .catch((error) => {
            console.error('Error sending video chunk:', error);
          });
      });
    };

    recorder.start();
    setMediaRecorder(recorder);
  };


  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
    }

    if (videoStream) {
      videoStream.getTracks().forEach(track => track.stop());
    }

    // if (videoRef.current) {
    //   videoRef.current.srcObject = null; 
    // }
    if (speechSynthesis) {
      speechSynthesis.cancel();
    }

  };

  const getISTISOString = () => {
    const date = new Date();
    const offset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + offset);
    return istDate.toISOString().replace('Z', '');
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && (e.key === 't' || e.key === 'n' || e.key === 'w')) {
        e.preventDefault();
      }

      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
        e.preventDefault();
      }

      if (isFullscreen && e.key === 'Escape') {
        e.preventDefault();
      }
    };


    const handleVisibilityChange = async () => {
      if (!isExamEnded && document.hidden) {
        const interviewId = localStorage.getItem(`${courseName}-interviewId`);
        const newAttemptCount = tabSwitchAttempts + 1;

        const payload = {
          interviewId,
          userId,
          tabSwitchCount: newAttemptCount,
        };

        if (newAttemptCount >= 3) {
          payload.status = "ENDED";
          payload.endReason = "Exam ended because user switched tabs too many times";
          payload.endedByUser = false;
          payload.endTime = getISTISOString();
        }

        try {
          await axios.post(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/user/event`, payload);
        } catch (e) {
          console.error(e);
        }

        setTabSwitchAttempts(newAttemptCount);

        alert(`Do not open new tabs during the interview. You've switched tabs ${newAttemptCount} times. The session will close after 3 attempts.`);
        // toast.dismiss();
        // toast.error(`Do not open new tabs during the interview. You've switched tabs ${newAttemptCount} times. The session will close after 3 attempts.`);

        if (newAttemptCount >= 3) {
          setIsGeneratingReport(false);
          endExam();
        }
      }
    };


    if (!isExamEnded && isPermissionGranted) {
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isExamEnded, isFullscreen, tabSwitchAttempts, isPermissionGranted, stopRecording]);

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    setIsFullscreen(true);
  };

  const endExam = () => {
    setIsExamEnded(true);
    stopRecording();
    // endInterview(); 
    navigate(`/unenrolled-ai-interview/${courseName}/${experience}/exam-ended`)
    if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
      exitFullscreen();
    }
  };
  const updateExamEndedEvent = async () => {
    const interviewId = localStorage.getItem(`${courseName}-interviewId`);

    const payload = {
      interviewId,
      userId,
    };

    payload.status = "ENDED";
    payload.endReason = "User explicitly clicked End Exam button";
    payload.endedByUser = true;
    payload.endTime = getISTISOString();


    try {
      await axios.post(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/user/event`, payload);
    } catch (e) {
      console.error(e);
    }
  }
  const handleEndInterview = () => {
    updateExamEndedEvent();
    endExam();
    if (speechSynthesis) {
      speechSynthesis.cancel();
    }
    setShowEndPopup(false)
  }
  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
  };

  const handleFullscreenChange = () => {
    if (!document.fullscreenElement) {
      setIsFullscreen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, []);

  const userId = String(localStorage.getItem('userId'));
  const userId2 = localStorage.getItem('userId');

  useEffect(() => {
    const getInterviewRemainingAttempts = async () => {
      try {
        const response = await axios.get(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/unenrolled/remaining-attempts/${userId}/${courseName}`);
        if (!response?.data?.allowed) {
          navigate(`/unenrolled-ai-interview/${courseName}/${experience}`);
        }
      } catch (error) {
        console.error("Error fetching remaining attempts:", error);
      }
    };
    getInterviewRemainingAttempts();
  }, [userId, id, courseName, experience, navigate]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        (event.key === 'F5') ||
        (event.ctrlKey && event.key === 'r') ||
        (event.metaKey && event.key === 'r')
      ) {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const startInterview = async () => {
    try {
      const response = await fetch(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/start`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          courseName: courseName
        }),
      });
      const data = await response.json();
      if (data.interviewId) {
        // console.log("Interview started with ID:", data.interviewId);
        localStorage.setItem(`${courseName}-interviewId`, data.interviewId);
      }
    } catch (error) {
      console.error("Error starting interview:", error);
    }
  };
  const [similarityScores, setSimilarityScores] = useState([]);
  const [evaluatePromises, setEvaluatePromises] = useState([]);

  const submitAnswer = async (question, answerText, audioFile) => {
    const formData = new FormData();
    formData.append("audioData", audioFile);
    formData.append("question", question);
    formData.append("answer", answerText);
    formData.append("userId", userId);
    const interviewId = localStorage.getItem(`${courseName}-interviewId`);

    try {
      await fetch(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/${interviewId}/question_answer`, {
        method: "POST",
        body: formData,
      });
    } catch (error) {
      console.error("Error submitting answer:", error);
    }

    const formData2 = new FormData();
    formData2.append("audio", audioFile);
    formData2.append("question", question);
    formData2.append("studentId", userId);

    const evaluatePromise = fetch(`${AI_INTERVIEW_URL}/experience/evaluate/nonEnrolled`, {
      method: "POST",
      body: formData2,
    })
      .then(async (response) => {
        if (response.status === 400) {
          return;
        }

        let scoreData = {
          transcribed_text: "its a conceptual question/ Error",
        };

        if (response.ok) {
          const result = await response.json();
          const score = result.similarity_score;

          if (score !== undefined) {
            scoreData = {
              question: result?.question,
              expected_answer: result.expected_answer,
              confidence_level: result.confidence_level || "Low",
              transcribed_text: result.transcribed_text || "No transcription available",
              similarity_score: score,
            };
          } else {
            console.error("No similarity score in response.");
          }
        } else {
          console.error("Error fetching evaluation result:", response.status);
        }

        setSimilarityScores((prevScores) => [
          ...prevScores,
          scoreData,
        ]);
      })
      .catch((error) => {
        console.error("Error submitting evaluation:", error);

        setSimilarityScores((prevScores) => [
          ...prevScores,
          {
            transcribed_text: "its a conceptual question",
          },
        ]);
      });

    setEvaluatePromises((prevPromises) => [...prevPromises, evaluatePromise]);
  };



  const endInterview = async (videoFile) => {
    setIsLoadingFinalReport(false);

    setIsGeneralLoading(true);

    const interviewId = localStorage.getItem(`${courseName}-interviewId`);

    if (!interviewId) {
      console.error("Interview ID is missing. Cannot end interview.");
      return;
    }

    const formData = new FormData();
    formData.append("finalVideoData", videoFile);
    formData.append("userId", userId);

    try {
      const response = await fetch(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/${interviewId}/end_exam`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {


        console.log("Interview ended successfully.");
        setTimeout(() => {
          console.log("Navigating to result page...");
          navigate(`/unenrolled-ai-interview/${courseName}/${experience}/result`);

          setIsGeneralLoading(false);

        }, 100);

      } else {
        console.error(`Failed to end interview: ${response.statusText}`);
      }

    } catch (error) {
      console.error("Error ending interview:", error);
    } finally {
      // localStorage.removeItem(`${courseName}-interviewId`);
    }
  };



  const generateQuizFinalReport = async () => {
    if (similarityScores.length === 0) {
      console.error("No similarity scores available for report generation.");
      return;
    }

    setIsGeneratingReport(true);// not useful already at evaluation we kept

    try {
      const response = await fetch(`${AI_INTERVIEW_URL}/experience/generate/nonEnrolled?studentId=${userId}`, {
        method: "POST",
        body: JSON.stringify(similarityScores),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      localStorage.removeItem(`reportScores-${courseName}-${experience}-${userId}`);
      localStorage.setItem(`reportScores-${courseName}-${experience}-${userId}`, JSON.stringify(result));
      const targetLanguages = ["python", "c", "c++", "java"];

      const escapeRegex = (str) =>
        str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const courseNameLower = courseName.toLowerCase();

      const match = targetLanguages.some((lang) => {
        const escapedLang = escapeRegex(lang.toLowerCase());
        const regex = new RegExp(`\\b${escapedLang}\\b`, 'i');
        return regex.test(courseNameLower);
      });

      if (courseName && match) {
        if (result.result !== "Pass") {
          stopRecording();
          // setIsGeneratingReport(false);
        }
        else {

          const randomQuestionNumbers = [
            Math.floor(Math.random() * 10) + 1,
            Math.floor(Math.random() * 10) + 1,
          ];

          while (randomQuestionNumbers[0] === randomQuestionNumbers[1]) {
            randomQuestionNumbers[1] = Math.floor(Math.random() * 10) + 1;
          }

          setQuestions(randomQuestionNumbers?.map((num, index) => ({
            question: num,
            isCoding: true,
            codingQuestionIndex: index + 1
          })));

          console.log("currentIndex after randomQuestionNumbers", currentQuestionIndex);
          setIsGeneratingReport(false);

        }
      }
      else {
        setIsExamSubmitted(true);

        const randomQuestionNumbers = [
          Math.floor(Math.random() * 10) + 1,
          Math.floor(Math.random() * 10) + 1,
        ];

        while (randomQuestionNumbers[0] === randomQuestionNumbers[1]) {
          randomQuestionNumbers[1] = Math.floor(Math.random() * 10) + 1;
        }
        setQuestions(randomQuestionNumbers?.map((num, index) => ({
          question: "",
          isCoding: false,
          codingQuestionIndex: index + 1
        })));
        stopRecording();
        setIsGeneratingReport(false);

      }

    } catch (error) {
      console.error("Error generating final report:", error);
    }
  };

  // const fetchCodingQuestions = async () => {
  //   try {

  //     const randomQuestionNumbers = [
  //       Math.floor(Math.random() * 10) + 1,
  //       Math.floor(Math.random() * 10) + 1,
  //     ];

  //     setQuestions(randomQuestionNumbers.map((num, index) => ({
  //       question: num,
  //       isCoding: true,
  //       codingQuestionIndex: index + 1
  //     })));

  //     // const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
  //     //  setVideoStream(stream);

  //     // if (videoRef.current) {
  //     //   videoRef.current.srcObject = videoStream;
  //     // }
  //   } catch (error) {
  //     console.error("Error fetching coding questions:", error);

  //   }
  //   finally {
  //     setIsGeneratingReport(false);

  //   }
  // };


  const handlePermissionAsk = async () => {
    toast.dismiss();

    if (!resume) {
      toast.error("Please upload a resume ");
      setIsLoadingExam(false);
      return;
    }
    setIsLoading(true);

    try {
      console.log("Supported constraints:", navigator.mediaDevices.getSupportedConstraints());

      const devices = await navigator.mediaDevices.enumerateDevices();
      console.log("Devices after permission:", devices);

      const videoDevices = devices.filter(device => device.kind === "video");
      console.log("Available video devices:", videoDevices);

      let frontCamera = videoDevices.find(device => device.label.toLowerCase().includes("front"))
        || videoDevices.find(device => device.label.toLowerCase().includes("webcam") || device.label.toLowerCase().includes("camera"))
        || videoDevices[0];

      let constraints = frontCamera
        ? {
          video: { deviceId: { exact: frontCamera.deviceId } },
          audio: true
        }
        : {
          video: {
            facingMode: "user",
            width: { ideal: 640 },
            height: { ideal: 480 }
          },
          audio: true
        };

      try {
        enterFullscreen();

        await fetchQuestions();

        setIsPermissionGranted(true);
        const currentQuestion = questions[currentQuestionIndex];
        readAloud(currentQuestion?.question);

        const finalStream = await navigator.mediaDevices.getUserMedia(constraints);
        setVideoStream(finalStream);
        startRecording(finalStream);
      } catch (error) {
        if (error.name === "OverconstrainedError") {
          console.warn("facingMode not supported, retrying with general constraints");

          const retryStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
          setVideoStream(retryStream);
          startRecording(retryStream);
        } else {
          throw error;
        }
      }

      // try {
      // enterFullscreen();

      // await fetchQuestions();

      // setIsPermissionGranted(true);

      // const currentQuestion = questions[currentQuestionIndex];
      // readAloud(currentQuestion?.question);
      // }
      // catch (error) {
      //    stopRecording();
      //   exitFullscreen();
      //   setIsPermissionGranted(false);

      // }

    } catch (error) {
      if (error?.message) {
        setErrorMessage(error?.message || "An unexpected error occurred");
      }
      else {
        setErrorMessage(error || "An unexpected error occurred");

      }
      stopRecording();
      // setIsPermissionGranted(false);

    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (isPermissionGranted && videoStream) {
      if (videoRef.current) {
        videoRef.current.srcObject = null;
        videoRef.current.srcObject = videoStream;
        videoRef.current.onloadedmetadata = () => {

          videoRef.current.play().catch(error => {
            console.error('Error attempting to play video:', error);
          });

        };

        document.body.addEventListener("click", () => {
          if (videoRef.current) {
            videoRef.current.play().catch(err => console.error("User interaction play error:", err));
          }
        }, { once: true });

      }
      const currentQuestion = questions[currentQuestionIndex];
      if (currentQuestion?.question && !currentQuestion?.isCoding) {
        readAloud(currentQuestion?.question);
      }
    }

  }, [isPermissionGranted, videoStream, questions]);


  // useEffect(() => {

  //   return () => {
  //     window.location.reload();
  //     stopRecording();
  //   }
  // }, [])

  // useEffect(() => {

  //   return () => {
  //     stopRecording();
  //   }
  // }, [navigate])

  useEffect(() => {

    return () => {
      //  stopRecording();
      if (speechSynthesis) {
        speechSynthesis.cancel();
      }
      window.location.reload();

    }
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer((prev) => prev - 1);
      } else {
        const isLastQuestion = currentQuestionIndex === questions?.length - 1;
        const isNonCoding = !questions[currentQuestionIndex]?.isCoding;

        if (
          currentQuestionIndex < questions?.length - 1 &&
          isNonCoding &&
          isPermissionGranted
        ) {
          moveToNextQuestion();
        } else if (!isNonCoding &&
          isPermissionGranted) {
          triggerRunFromParent();
          moveToNextQuestionCode();
        }
        else if (
          isLastQuestion &&
          isNonCoding &&
          isPermissionGranted
        ) {
          if (!hasRecordedAnswer) {
            finishInterview();
          } else {
            toast.dismiss();

            toast.error("Please answer before submission");
          }
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timer, currentQuestionIndex]);
  const questionEditorRef = useRef();

  const triggerRunFromParent = () => {
    if (questionEditorRef.current) {
      questionEditorRef.current.handleSubmit();
    }
  };
  useEffect(() => {
    if (!userId2) {
      navigate('/login');
    }

  }, [navigate, userId, id]);



  const [audioRecorder, setAudioRecorder] = useState(null);

  const startAudioRecording = async () => {
    if (speechSynthesis) {
      speechSynthesis.cancel();
    }
    if (!hasRecordedAnswer) {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      const recorder = new MediaRecorder(stream);
      let tempChunks = [];

      recorder.onstart = () => {    // console.log("Recording started successfully.");
        setIsAudioRecording(true);
      };

      recorder.ondataavailable = (event) => { // console.log("Audio data available:", event.data);
        tempChunks.push(event.data);
      };

      recorder.onstop = () => { // console.log("Recording stopped.");
        const audioBlob = new Blob(tempChunks, { type: "audio/webm" });

        if (audioBlob.size > 0) {
          // URL.createObjectURL(audioBlob); // console.log("Audio URL:", audioUrl);

          setAudioRecordings((prev) => [
            ...prev,
            {
              question: questions[currentQuestionIndex]?.question,
              audioFile: audioBlob,
              answerText,
            }
          ]);
          setHasRecordedAnswer(true);
          setIsAudioRecording(false);
          setIsAnswered(true);
        } else {
          console.error("Audio Blob is empty!");
        }
      };

      recorder.start();
      setAudioRecorder(recorder);
    } else {
      toast.dismiss();

      toast.error("You are allowed to attempt the question only once!");
    }
  };

  const stopAudioRecording = () => {
    if (audioRecorder && isAudioRecording) {
      // console.log("Stopping recording...");
      audioRecorder.stop();
      setIsAudioRecording(false);
    } else {
      // console.log("Recording has already stopped or was never started.");
    }
  };

  const sendQuestionAnswer = async (question, answerText, audioFile) => {
    if (!audioFile && timer > 1) {
      console.error("Audio file is invalid or missing.");
      return;
    }
    submitAnswer(question, answerText, audioFile || null);
  };

  // const handleTextChange = (event) => {
  //   setAnswerText(event.target.value);
  //   if (event.target.value.trim() !== '') {
  //     setIsAnswered(true);
  //   }
  // };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  const handleCopyPasteCut = (e) => {
    e.preventDefault();
  }

  useEffect(() => {
    const handleDisableRightClick = (e) => {
      e.preventDefault();
    }

    document.addEventListener('contextmenu', handleDisableRightClick);
    return () => {
      document.removeEventListener('contextmenu', handleDisableRightClick);

    }
  }, [])

  // const currentAudi = audioRecordings[currentQuestionIndex - 1];
  // const audioUrl = currentAudi?.audioFile ? URL.createObjectURL(currentAudi.audioFile) : null;

  // if (!audioFile && timer>1) {
  //   console.error("Audio file is invalid or missing.");
  //   // toast.error('Audio file is invalid or missing.');
  //   return;
  // }
  const moveToNextQuestion = () => {
    // stopAudioRecording();

    if (currentQuestionIndex >= 0 && currentQuestionIndex < questions?.length) {
      const currentAudio = audioRecordings[currentQuestionIndex];

      if (currentAudio?.audioFile) {
        sendQuestionAnswer(currentAudio?.question, currentAudio.answerText, currentAudio.audioFile);
      } else {
        if (timer > 0) {
          toast.dismiss();
          toast.error("Please answer before submission");
          return;
        }

        const currentQuestion = questions[currentQuestionIndex];
        setAudioRecordings((prev) => [
          ...prev,
          {
            question: currentQuestion?.question || '',
            audioFile: null,
            answerText,
          },
        ]);

        setSimilarityScores((prevScores) => [
          ...prevScores,
          {
            question: currentQuestion?.question || '',
            confidence_level: "Low",
            transcribed_text: "Answer Skipped by user",
            similarity_score: 0.0,
            expected_answer: "User Not answered",
          },
        ]);

        setAnswerText('');
      }
    } else {
      console.log("Invalid currentQuestionIndex or out of bounds");
    }


    setCurrentQuestionIndex((prevIndex) => {
      const nextIndex = prevIndex + 1; // console.log("Moving to next question index:", nextIndex);
      return nextIndex;
    });

    setTimer(180);

    const currentQuestion = questions[currentQuestionIndex + 1];

    speechSynthesis.cancel();


    readAloud(currentQuestion?.question);

    if (currentQuestionIndex + 1 >= questions?.length) {
      return;
    }
    setIsAudioRecording(false);
    setHasRecordedAnswer(false);
  };


  const readAloud = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    speechSynthesis.speak(utterance);
  };

  const sendAnswerToBackend = () => {

    if (audioRecordings.length > 0) {
      const currentAudio = audioRecordings[currentQuestionIndex];
      if (currentAudio?.audioFile) {
        sendQuestionAnswer(currentAudio?.question, currentAudio.answerText, currentAudio?.audioFile);
      } else {
        if (timer > 0 && answerText.trim().length === 0) {
          toast.dismiss();
          toast.error("Please answer before submission");
          return;
        }
        const currentQuestion = questions[currentQuestionIndex];
        setAudioRecordings((prev) => [
          ...prev,
          {
            question: currentQuestion?.question || '',
            audioFile: null,
            answerText,
          }]);

        sendQuestionAnswer(currentQuestion?.question || '', answerText, null);
        setAnswerText('');
      }
    }

  };

  const finishInterview = async () => {
    setIsGeneratingReport(true);
    sendAnswerToBackend();
    speechSynthesis.cancel();
    setTimer(900);
    console.log("currentIndex before finish", currentQuestionIndex);
    setQuestions('');
    setCurrentQuestionIndex(0);
    console.log("currentIndexfrom finish", currentQuestionIndex);

    try {
      await Promise.all(evaluatePromises);
      // await generateQuizFinalReport();
    } catch (error) {
      console.error("Error during evaluation or report generation:", error);
    }

  };

  console.log(localStorage.getItem("experience"))


  useEffect(() => {
    const storedLength = parseInt(localStorage.getItem("length"), 10);

    if (similarityScores.length === storedLength) {
      console.log(similarityScores, storedLength);
      generateQuizFinalReport();
    }
  }, [similarityScores.length]);


  const studentId = localStorage.getItem('userId');
  const [codingQuestionCount, setCodingQuestionCount] = useState(0);


  const moveToNextQuestionCode = () => {

    if (currentQuestionIndex === questions?.length - 1) {
      setIsLoadingFinalReport(true);
      handleFinalReport();
      setTimer(900);
    }
    else {
      setTimer(900);

      setCurrentQuestionIndex((prevIndex) => {

        const nextIndex = prevIndex + 1;
        return nextIndex;
      });
    }

  }

  const handleFinalReport = async () => {
    try {
      try {
        await axios.post(`${PROGRAMMINGSERVICE_URL}/questions/generate/${studentId}`);
      } catch (error) {
        console.error("Error generating questions:", error);
      }

      try {
        await axios.get(`${AI_INTERVIEW_URL}/questions/generate/student?studentId=${studentId}`);
      } catch (error) {
        console.error("Error getting report:", error);
      }

      let finalResponse;
      try {
        finalResponse = await axios.post(`${PROGRAMMINGSERVICE_URL}/questions/finalReport/generate/${studentId}`);
      } catch (error) {
        const message = error?.response?.data || "An unexpected error occurred.";
        finalResponse = {
          data: {
            isFailed: true,
            message: message,
          }
        };
        console.error("Error generating final report:", message);
      }

      stopRecording();

      if (document.fullscreenElement) {
        exitFullscreen();
      }
      let existingData = localStorage.getItem(`reportScores-${courseName}-${experience}-${userId}`);
      existingData = existingData ? JSON.parse(existingData) : {};

      const codingData = finalResponse.data || {};
      try {
        await fetch(`${INTERVIEWMANAGEMENT_URL}/v1/interviews/unenrolled/${userId}/${courseName}/result?result=${codingData.finalResult}`, {
          method: "POST",
        });
      } catch (error) {
        console.error("error saving final report:", error);
      }


      console.log("coding data", codingData);
      const mergedData = {
        ...existingData,
        ...codingData
      };
      console.log("mergedData data", mergedData);

      localStorage.setItem(`reportScores-${courseName}-${experience}-${userId}`, JSON.stringify(mergedData));


    } catch (error) {
      console.error("Error generating final report:", error);

    }
    finally {
      // setIsLoadingFinalReport(false);

      stopRecording();

      if (document.fullscreenElement) {
        exitFullscreen();
      }
    }
  };



  const convertSeconds = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes} m ${seconds} s`;
  };

  if (isGeneratingReport || isLoadingExam || isLoadingFinalReport || isGeneralLoading) return (
    <div className="ai-interview-exam-container-loading">
      <div className="loading-overlay">
        <div className="spinner-wrapper">
          <ClipLoader color="#0B89C2" loading={true} size={70} css={` position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); `} />
          {isGeneratingReport && <p className='loading-note'>Please wait while we submit your answers. This process may take 3-4 minutes. Kindly avoid refreshing the page, as it may interrupt the submission.</p>}
          {isLoadingExam && <p className='loading-note'>Questions are being generated. Please wait, this may take up to 2 minutes.</p>}
          {isLoadingFinalReport && <p className='loading-note'>Please wait while we submit your coding answers and generate the final report. This may take up to 2 minutes.  Kindly avoid refreshing the page, as it will cancel the upload.</p>}
          {isGeneralLoading && <p>Please wait for 2 minutes while the final report is being generated.</p>}
        </div>
      </div>
    </div>
  );

  return (
    <div >
      {
        showEndPopup &&
        <div className='overlay-ai-interview'>
          <div className='overlay-ai-interview-child'> <h3>Do you want to end the interview?</h3>
            <div>
              <button onClick={handleEndInterview}>Yes</button>  <button onClick={() => setShowEndPopup(false)}>No</button>
            </div>
          </div>
        </div>
      }
      {!isPermissionGranted ? (
        <div className="request-permissions-container">
          <div className="request-permissions">
            <h1>Permission Request</h1>
            <p>To proceed, we need access to your microphone and camera for the exam.</p>
            <div className='upload-resume-label'>
              <label htmlFor="resume-input" ><b>Upload Resume:</b></label>
              <input
                type="file"
                id="resume-input"
                accept=".pdf,.doc,.docx"
                onChange={handleResumeChange}
              />
            </div>

            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <button className="certificate-btn" onClick={handlePermissionAsk} disabled={isLoading} style={{ backgroundColor: '#0B89C2' }}>
              {isLoading ? 'Requesting permissions...' : 'Confirm and Start Exam'}
            </button>

            {/* <video controls>
              <source src="https://instructorcourses.s3-accelerate.amazonaws.com/AI-interview-recordings/70/20250405_065212_video.mp4" />
            </video> */}

            <button className="certificate-btn" onClick={() => navigate("/")}>
              Go to Home
            </button>

          </div>
        </div>
      ) : (
        !isExamEnded ?

          (
            !isExamSubmitted ?
              <div className="ai-interview-exam-container">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    {questions?.map((_, index) => (
                      <span
                        key={index}
                        style={{
                          marginRight: '5px', display: 'inline-block', width: `${100 / questions?.length}%`,
                          maxWidth: '29%', height: '5px',
                          backgroundColor: index === currentQuestionIndex ? '#17a2e1' : '#b0d5f1', borderRadius: '10px'
                        }} />
                    ))}
                  </div>

                  <div style={{ marginLeft: '10px', color: 'black', fontWeight: 'bold' }}>
                    ({currentQuestionIndex + 1}/{questions?.length})
                  </div>
                </div>
                <div className="ai-interview-exam">
                  <div className="ai-interview-exam-subcontainer">
                    <p>Time left: {convertSeconds(timer)}</p>

                    <div className="ai-question-container">
                      {/* {currentQuestionIndex + 1}. */}
                      {
                        !questions[currentQuestionIndex]?.isCoding && <p className="ai-interview-question">
                          {questions[currentQuestionIndex]?.question}
                        </p>
                      }
                      {questions[currentQuestionIndex]?.isCoding ? (
                        <div className="ai-interview-exam-subcontainer">
                          {codingQuestionCount < 2 ? (

                            <QuestionEditor
                              ref={questionEditorRef}

                              questionNum={questions[currentQuestionIndex]?.question}
                              moveToNextQuestionCode={moveToNextQuestionCode}
                              codingQuestionIndex={questions[currentQuestionIndex]?.codingQuestionIndex}
                              setCodingQuestionCount={setCodingQuestionCount}
                              studentId={studentId}
                              handleCopyPasteCut={handleCopyPasteCut}
                              experienceLevel={localStorage.getItem("experience")}
                            />
                          ) : (
                            <div className="ai-interview-exam">
                              Please wait, coding questions are being submitted.
                            </div>
                          )}

                        </div>
                      ) : (
                        <div className="microphone-container">
                          <button
                            onClick={isAudioRecording ? stopAudioRecording : startAudioRecording}
                            className={isAudioRecording ? 'recording-button' : 'mic-button'}
                          >
                            {!isAudioRecording ? (
                              <FaMicrophone size={30} color="white" />
                            ) : (
                              <>
                                <FaMicrophone size={30} color="white" className='recording-button' />
                              </>
                            )}
                          </button>
                          {
                            isAudioRecording ? <p>Tap the mic to stop recording</p>
                              :
                              <p>Tap the mic to start recording your answer</p>
                          }
                        </div>
                      )}

                      {!questions[currentQuestionIndex]?.isCoding && (
                        <button
                          onClick={() => {
                            const isLastQuestion = currentQuestionIndex === questions.length - 1;

                            if (isLastQuestion) {
                              if (hasRecordedAnswer) {
                                finishInterview();
                              } else {
                                toast.dismiss();

                                toast.error("Please answer before submission.");
                              }
                            } else {
                              moveToNextQuestion();
                            }
                          }}
                          className="next-submit-button"
                        >
                          {currentQuestionIndex === questions.length - 1 ? 'Submit & Finish' : 'Submit & Continue'}
                        </button>
                      )}




                      <p className='ai-interview-note'>Note : Do not refresh the page, or the interview will end.</p>
                    </div>
                  </div>
                  {videoStream && (
                    <>
                      <div className="ai-interview-exam-video-preview">
                        {renderSignalBars()}

                        <video ref={videoRef} autoPlay muted playsInline className="video-preview" />
                        <img
                          src={interviewerImg}
                          alt="Interviewer"
                          style={{
                            position: 'fixed',
                            bottom: '16px',
                            left: '16px',
                            width: '25vw',
                            maxWidth: '300px',
                            height: 'auto',
                            aspectRatio: '5 / 4',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            border: '2px solid white',
                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
                            backgroundColor: '#f0f0f0',
                            zIndex: 1000,
                          }}
                        />

                        <button className='end-interview-btn' onClick={() => setShowEndPopup(true)}>End Interview</button>
                        {/* <button onClick={moveToNextQuestionCode} >move to next question</button> */}

                      </div>
                    </>
                  )}
                </div>

              </div> :
              <div>
                Please wait for 2 minutes while the final report is being generated.
              </div>
          )

          :
          <>
            <p className="request-permissions-container">The exam has ended.</p>
            <button className="certificate-btn" onClick={() => navigate("/")}>Go to Home</button>
          </>
      )}
    </div>
  );
};

export default AIInterviewExamUnenrolledCourse;